import { Component, Inject, OnInit, Optional } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';
import { TipoAltroSoggetto } from 'src/app/models/tipo-altro-soggetto';
import { BaseEditForm } from 'src/app/shared/baseEditForm';


@Component({
  selector: 'tipi-altro-soggetto-form',
  templateUrl: './form.component.html',
  styleUrls: ['./form.component.scss']
})
export class TipiAltroSoggettoFormComponent extends BaseEditForm implements OnInit {

  tipoAltroSoggetto: TipoAltroSoggetto;
  form: FormGroup;
  constructor(private fb: FormBuilder,
    private toast: ToastrService,
    public dialogRef: MatDialogRef<TipiAltroSoggettoFormComponent>,
    @Optional() @Inject(MAT_DIALOG_DATA) public data: TipoAltroSoggetto,) {
    super();
    this.tipoAltroSoggetto = data;
  }

  ngOnInit() {

    this.form = this.fb.group({
      nome: [this.tipoAltroSoggetto?.nome, Validators.required],
    });
  }

}

